export default {"src":"/login-app/[GIT_HASH]/_next/static/media/unfold_more.7fba036b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};